import { colorConstants } from 'config/colorConstants';
import _ from 'lodash';
import { formatNumWithKMBAlt, getAbsoluteChange, getPercentageChangeV2 } from 'utils/helperMethods';

const rowCount = 3;
let lag1Title = '52 W/E 2 January, 2022';
let lag0Title = '52 W/E 1 January, 2023';

const featureGroupLabelMapping: any = {
    cogs: 'COGS',
};

const alterValueKeys = {
    retailer: ['list_price', 'retail_discounts'],
    own: ['cogs', 'trade_spends'],
    sales_attribution: [''],
};

const unexplainedKeys = {
    retailer: 'retailer_volume',
    own: 'manufacturer_volume',
    sales_attribution: 'unexplained',
};

const header = ['structural demand', 'execution', 'other factors', 'unexplained'];
export const salesAttributeDataParser = (
    data: any,
    isProfitPool: boolean = false,
    from: 'sales_attribution' | 'own' | 'retailer' = 'sales_attribution',
) => {
    try {
        lag0Title = data?.totalSalesData?.[0]?.label || lag0Title;
        lag1Title = data?.totalSalesData?.[1]?.label || lag1Title;
        //chart data 1st row
        const featureGroupData: any = {
            scale: null,
            initial: isProfitPool ? 0 : null,
        };
        //chart data 2nd row
        const featureIndividualItemData: any = {
            scale: null,
            initial: isProfitPool ? 0 : null,
        };

        //CHART DATA 3RD ROW
        const chartLabelData: any = {
            scale: null,
            initial: [lag1Title],
        };
        //chart data 2nd row
        const tableData: any = {
            scale: [],
        };

        const headerTitle = isProfitPool ? ['', lag1Title] : ['', '']; //group header title
        let maxValue = 0; //this value is calculated so that it can be used in chart as maxBound
        let minValue = 0; //this value is calculated so that it can be used in chart as minBound
        let totalItemsLength = 2; //given 2 includes lag0 and lag1

        let { totalSalesData } = data;
        // let featureGroups = _.cloneDeep(data.featureGroups);
        let featureGroups = data.featureGroups;
        if (!isProfitPool) {
            featureGroups = featureGroups.map((item: any) => {
                const features = [
                    {
                        featureName: item?.groupName,
                        value: item?.groupValue,
                    },
                ];
                return {
                    ...item,
                    features,
                };
            });
        }

        //order changing code
        // for (let i = 0; i < header.length; i++) {
        //     console.log(featureGroups, 'logging groups');
        //     if (featureGroups[i].groupName?.toLowerCase() != header[i]) {
        //         const index = featureGroups.findIndex((elem: any) => elem.groupName?.toLowerCase() == header[i]);
        //         const temp = featureGroups[index];
        //         const temp2 = featureGroups[i];
        //         featureGroups[i] = temp;
        //         featureGroups[index] = temp2;
        //     }
        // }
        const lag0Data = totalSalesData[0].value;
        const lag1Data = totalSalesData[1].value;
        tableData['initial'] = [parseYearlyData(lag1Title, [0, lag1Data])];

        let previousVal = lag1Data; //storing prev values so that it can be used to produce continues values for waterfall chart
        let totalPercentageSum = 0;
        featureGroups.map((item: any) => {
            const { groupName, features } = item;
            headerTitle.push(
                groupName in featureGroupLabelMapping ? featureGroupLabelMapping[groupName] : _.startCase(groupName),
            );
            const parsedGroupNameKey = _.snakeCase(groupName);

            let featurePercentageSum = 0;

            const parsedFeatureData = features.map((feature: any) => {
                let val = feature.value;
                //alter the value if present in alterValueKeys
                val = alterValueKeys[from]?.includes(groupName) ? val * -1 : val;
                const newVal = previousVal + val;
                const change = [previousVal, newVal];
                const formattedFeatureName =
                    feature.featureName in featureGroupLabelMapping
                        ? featureGroupLabelMapping[feature.featureName]
                        : _.startCase(feature.featureName);
                totalItemsLength += 1;
                maxValue = Math.max(...change, maxValue, lag0Data, lag1Data);
                minValue = Math.min(...change, minValue, lag0Data, lag1Data);
                previousVal = newVal;

                const featurePercentage = calcPercentage(val, lag1Data);
                featurePercentageSum += featurePercentage;

                featureIndividualItemData[parsedGroupNameKey] =
                    parsedGroupNameKey in featureIndividualItemData
                        ? [...featureIndividualItemData[parsedGroupNameKey], featurePercentage]
                        : [featurePercentage];

                chartLabelData[parsedGroupNameKey] =
                    parsedGroupNameKey in chartLabelData
                        ? [...chartLabelData[parsedGroupNameKey], formattedFeatureName]
                        : [formattedFeatureName];
                return {
                    type: feature.featureName,
                    change,
                };
            });
            tableData[parsedGroupNameKey] = parsedFeatureData;
            featureGroupData[parsedGroupNameKey] = featurePercentageSum;
            totalPercentageSum += featurePercentageSum;
        });
        // totalItemsLength += 1; // for unexplained
        const featureGroupDataOverall = calcPercentage(lag0Data - lag1Data, lag1Data);

        // //unexplained
        // const keyName = unexplainedKeys[from];
        // const unexplainedTitle = _.startCase(keyName);
        // featureGroupData[keyName] = featureGroupDataOverall - totalPercentageSum;
        // tableData[keyName] = [{ type: keyName, change: [previousVal, lag0Data] }];
        // chartLabelData[keyName] = [unexplainedTitle];
        // featureIndividualItemData[keyName] = featureGroupDataOverall - totalPercentageSum;
        // headerTitle.push(unexplainedTitle);

        //overall
        tableData['overall'] = [parseYearlyData(lag0Title, [0, lag0Data])];
        featureGroupData['overall'] = featureGroupDataOverall;
        featureIndividualItemData['overall'] = isProfitPool ? [featureGroupDataOverall] : null;
        chartLabelData['overall'] = [lag0Title];
        headerTitle.push(isProfitPool ? lag0Title : 'Overall');

        maxValue = maxValue + maxValue / 10; //adding a buffer to maxValue so that chart does not overflow
        minValue = minValue > 0 ? minValue - minValue / 10 : minValue + (minValue - 2) / 10; //adding a buffer to minValue so that chart does not overflow
        return {
            data: [featureGroupData, tableData, chartLabelData, featureIndividualItemData], //stores data
            extra: { maxValue, minValue, length: totalItemsLength, headerTitle }, //stores all the extra info required
        };
    } catch (error) {
        console.log(error, 'logging error');
        throw [];
    }
};

const parseYearlyData = (type: string, data: Array<any>) => {
    return {
        type,
        change: data,
    };
};

const calcPercentage = (num: number, den: number) => {
    //if (!den) return null;
    return _.round((num / den) * 100, 2);
};

export const salesAttributionFeatureLevelParser = (
    data: any[],
    itemKey: string = '',
    nameKey: string = '',
    formatName: boolean = false,
    salesAttributionDrillDownChartKeyValueMapping: any = {},
) => {
    const result: any = {
        minVal: { abs: 0, percentage: 0 },
        maxVal: { abs: 0, percentage: 0 },
        maxCharacters: 0, //calculating the length of word with max characters to determine height of row
        data: { abs: [], percentage: [] },
    };
    try {
        const absData: any[] = [];
        const percentageData: any[] = [];
        data?.forEach((feature: any) => {
            const name = formatName
                ? feature?.[nameKey] in salesAttributionDrillDownChartKeyValueMapping
                    ? salesAttributionDrillDownChartKeyValueMapping?.[feature?.[nameKey]]
                    : _.startCase(feature?.[nameKey])
                : feature?.[nameKey];
            const item = feature?.[itemKey];
            //  const absSales = getAbsoluteChange(item[1]?.value, item[0]?.value);
            const absSales = _.isNull(item[0]) ? null : item[0];
            //  const percentageSales = getPercentageChangeV2(item[1]?.value, item[0]?.value);
            const percentageSales = _.isNull(item[1]) ? null : item[1];
            result.maxCharacters = Math.max(result.maxCharacters, name?.length || 0);
            //abs data
            absData.push({
                sales: absSales,
                labelSales: absSales,
                category: name,
                color: Number(absSales) < 0 ? colorConstants.red : colorConstants.limeGreen,
            });
            result.minVal.abs = Math.min(result.minVal.abs, Number(absSales));
            result.maxVal.abs = Math.max(result.maxVal.abs, Number(absSales));
            //percentage data
            percentageData.push({
                sales: percentageSales,
                labelSales: percentageSales,
                category: name,
                color: Number(percentageSales) < 0 ? colorConstants.red : colorConstants.limeGreen,
            });
            result.minVal.percentage = Math.min(result.minVal.percentage, Number(percentageSales));
            result.maxVal.percentage = Math.max(result.maxVal.percentage, Number(percentageSales));
        });
        result.data.abs = absData;
        result.data.percentage = percentageData;
        return result;
    } catch (error) {
        console.log(error, 'logging error');
        throw [];
    }
};
